/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


import Paper from "@mui/material/Paper";
import React from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import textCardStyle from "./textCardStyle";
import {Box} from "@mui/material";

type TextCardProps = {
  boxHeading: string;
  headingColor?: "default" | "primary";
  minHeadingHeight?: number;
  textAlign?: "left" | "center";
  boldText?: string;
  children: React.ReactNode;
};
const TextCard = ({
                    boxHeading,
                    headingColor = "default",
                    minHeadingHeight = 65,
                    textAlign = "left",
                    boldText,
                    children
                  }: TextCardProps) => {
  return (
    <Paper sx={textCardStyle.paper} elevation={4}>
      <Typography variant={"h3"}
                  sx={{...textCardStyle.boxHeading, ...textCardStyle[headingColor], minHeight: minHeadingHeight}}>
        {boxHeading}
      </Typography>
      <Box sx={textCardStyle[textAlign]}>{children}</Box>
      {boldText && (
        <>
          <Divider />
          <Typography sx={textCardStyle.boldText}>{boldText}</Typography>
        </>
      )}
    </Paper>
  );
};

export default TextCard;
